module.exports = "/_next/static/images/img_list-2-5014b674941d938e8acd067ec31a0f3f.webp";